module.exports = {
  src: __webpack_public_path__ + "assets/images/home-bg.fd424fc0e33ac937.png",
  width: 1477,
  height: 800,
  toString: function() { return __webpack_public_path__ + "assets/images/home-bg.fd424fc0e33ac937.png"; }
};